import { render, staticRenderFns } from "./WorkerBalanceVacationPage.vue?vue&type=template&id=564a5773&"
import script from "./WorkerBalanceVacationPage.vue?vue&type=script&lang=js&"
export * from "./WorkerBalanceVacationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports